import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { StatusBadge } from "@/components/StatusBadge";
import { OptimizedImage } from "@/components/OptimizedImage";
import { formatPrice, getFileUrl } from "@/lib/api";
import { Gauge, Calendar, Fuel } from "lucide-react";

export const ScooterCard = ({ scooter }) => {
  const defaultImage = "https://images.unsplash.com/photo-1608551883326-2c9bd5d52618?w=400&h=300&fit=crop";
  const imageUrl = scooter.photos?.[0] 
    ? getFileUrl(scooter.photos[0])
    : defaultImage;

  return (
    <Link to={`/stock/${scooter.scooter_id}`}>
      <Card 
        className="group overflow-hidden border-border bg-card hover:border-primary/50 transition-colors duration-300"
        data-testid={`scooter-card-${scooter.scooter_id}`}
      >
        <div className="relative overflow-hidden">
          <OptimizedImage
            src={imageUrl}
            alt={`${scooter.brand} ${scooter.model}`}
            fallback={defaultImage}
            className="group-hover:scale-105 transition-transform duration-500"
            aspectRatio="4/3"
          />
          <div className="absolute top-3 left-3 z-10">
            <StatusBadge status={scooter.status} />
          </div>
          <div className="absolute top-3 right-3 z-10">
            <span className="font-mono text-xs bg-black/70 text-white px-2 py-1 rounded">
              {scooter.scooter_id}
            </span>
          </div>
        </div>
        <CardContent className="p-4">
          <div className="mb-3">
            <h3 className="font-heading font-bold text-lg leading-tight">
              {scooter.brand} {scooter.model}
            </h3>
            <p className="text-muted-foreground text-sm font-mono mt-1">
              {scooter.year} • {scooter.engine_cc}cc • {scooter.color}
            </p>
          </div>
          
          <div className="flex items-center gap-4 text-xs text-muted-foreground mb-3">
            <span className="flex items-center gap-1">
              <Gauge className="w-3 h-3" />
              <span className="font-mono">{scooter.mileage.toLocaleString()} km</span>
            </span>
            <span className="flex items-center gap-1">
              <Calendar className="w-3 h-3" />
              <span className="font-mono">{scooter.year}</span>
            </span>
            <span className="flex items-center gap-1">
              <Fuel className="w-3 h-3" />
              <span className="font-mono">{scooter.engine_cc}cc</span>
            </span>
          </div>

          <div className="flex items-center justify-between pt-3 border-t border-border">
            <span className="text-xs text-muted-foreground">Price</span>
            <span className="font-mono font-bold text-primary text-lg">
              {formatPrice(scooter.selling_price)}
            </span>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};
